import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

interface FiltersWrapperProps {
  children: React.ReactNode
  className?: string
}

export const FiltersWrapper: React.FC<FiltersWrapperProps> = ({ children, className }) => {
  return (
    <Box paddingBottom="s16">
      <Box background="white" className={`${styles.stickyFilters} ${className || ''}`}>
        {children}
      </Box>
    </Box>
  )
}
